import * as React from "react"
import { cn } from "@/lib/utils"
import { Label } from "@/components/ui/label"

function Field({ label, htmlFor, hint, error, className, children, ...props }) {
  return (
    <div className={cn("space-y-1.5", className)} {...props}>
      <Label htmlFor={htmlFor} className="text-small font-medium text-ink">{label}</Label>
      {children}
      {error
        ? <p className="text-small text-status-overdue">{error}</p>
        : hint && <p className="text-small text-ink-muted">{hint}</p>}
    </div>
  )
}

export { Field }
